(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["divaderme-brow-story"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dd-brow-shade-guide')) {
  customElements.define('dd-brow-shade-guide', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('click', (event) => this.selectShade(event), { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    async selectShade(event) {
      const link = event.target.closest('a[data-dd-brow-shade]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const page = this.closest('.dd-brow-page');
      const picker = page?.querySelector('variant-picker[context="main_product"]');
      if (!picker || typeof picker.selectCombination !== 'function') return;
      const shade = link.dataset.ddBrowShade;
      const input = [...picker.querySelectorAll('input[type="radio"][data-option-position="1"]')].find((radio) => [...radio.labels].some((label) => label.textContent.trim() === shade));
      if (!input || input.disabled) return;
      event.preventDefault();
      if (this.selecting) return;
      this.selecting = true;
      this.setAttribute('aria-busy', 'true');
      try {
        if (!input.checked) await picker.selectCombination({ optionValues: [input.value], productChange: false });
        const currentPicker = page.querySelector('variant-picker[context="main_product"]');
        currentPicker?.querySelector('input[type="radio"]:checked')?.focus({ preventScroll: true });
        currentPicker?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
      } catch {
        const destination = new URL(link.href);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) destination.searchParams.set('preview_theme_id', preview);
        location.assign(destination.href);
      } finally {
        this.selecting = false;
        this.removeAttribute('aria-busy');
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["divaderme-lash-application"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dd-lash-application')) {
  customElements.define('dd-lash-application', class extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      this.cards = [...this.querySelectorAll('.dd-lash-step')];
      this.controller = new AbortController();
      this.preference = matchMedia('(prefers-reduced-motion: reduce)');
      const signal = this.controller.signal;
      this.preference.addEventListener('change', () => this.configure(), { signal });
      this.configure();
    }

    configure() {
      this.observer?.disconnect();
      this.motionController?.abort();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.visible = new Set();
      this.enabled = !this.preference.matches && this.dataset.designMode !== 'true' && 'IntersectionObserver' in window;
      this.dataset.motion = this.enabled ? 'on' : 'off';
      if (!this.enabled) {
        this.style.setProperty('--dd-application-progress', '1');
        this.cards.forEach(card => card.style.removeProperty('--dd-step-drift'));
        return;
      }
      this.motionController = new AbortController();
      const signal = this.motionController.signal;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.visible.add(entry.target);
            entry.target.classList.add('is-revealed');
          } else this.visible.delete(entry.target);
        });
        this.schedule();
      }, { threshold: .14 });
      this.cards.forEach(card => this.observer.observe(card));
      window.addEventListener('scroll', () => this.schedule(), { passive: true, signal });
      window.addEventListener('resize', () => this.schedule(), { passive: true, signal });
      document.addEventListener('visibilitychange', () => this.schedule(), { signal });
      this.addEventListener('load', () => this.schedule(), { capture: true, signal });
      this.schedule();
    }

    schedule() {
      if (!this.enabled || this.frame || document.hidden || !this.visible.size) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        if (!this.isConnected || !this.enabled) return;
        const height = innerHeight;
        const section = this.getBoundingClientRect();
        const progress = Math.max(0, Math.min(1, (height - section.top) / (height + section.height)));
        const updates = [...this.visible].map(card => {
          const rect = card.getBoundingClientRect();
          const position = Math.max(-1, Math.min(1, (height / 2 - (rect.top + rect.height / 2)) / height));
          return [card, (position * 18).toFixed(2) + 'px'];
        });
        this.style.setProperty('--dd-application-progress', progress.toFixed(4));
        updates.forEach(([card, drift]) => card.style.setProperty('--dd-step-drift', drift));
      });
    }

    cleanup() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.motionController?.abort();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
    }

    disconnectedCallback() { this.cleanup(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["divaderme-review-glass"] && !Shopify.designMode) return;
  try {
    (() => {
 const copy=document.getElementById('dd-review-copy');
 if(!copy)return;
 const enhance=()=>{
  const widget=document.getElementById('judgeme_product_reviews');
  const title=widget?.querySelector('.jm-review-widget-minimal-header__title');
  if(!title)return;
  if(title.textContent!==copy.dataset.title)title.textContent=copy.dataset.title;
  const rating=widget.querySelector('.jm-average-rating-display > .jm-cluster');
  if(rating&&!rating.querySelector('.dd-rating-stars')){
   const score=Number.parseFloat(rating.querySelector('.jm-text')?.textContent);
   if(Number.isFinite(score)){
    const stars=document.createElement('span');
    stars.className='dd-rating-stars';
    stars.setAttribute('aria-hidden','true');
    stars.textContent='★★★★★';
    stars.style.setProperty('--dd-rating-fill',Math.min(100,Math.max(0,score/5*100))+'%');
    rating.firstElementChild.after(stars);
   }
  }
  if(!widget.querySelector('.dd-review-eyebrow')){
   const eyebrow=document.createElement('p');
   eyebrow.className='dd-review-eyebrow';
   eyebrow.textContent=copy.dataset.eyebrow;
   title.before(eyebrow);
  }
 };
 let queued=false;
 const observer=new MutationObserver(()=>{
  if(queued)return;
  queued=true;
  requestAnimationFrame(()=>{queued=false;enhance();});
 });
 observer.observe(document.getElementById('main')||document.body,{childList:true,subtree:true});
 enhance();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["divaderme-ritual-preview-frame"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('divaderme-preview-frame')) {
    class DivadermePreviewFrame extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.addEventListener('click', event => {
          const button = event.target.closest('button[data-width]');
          if (!button || !this.contains(button)) return;
          const width = Number(button.dataset.width);
          if (![320, 390, 430, 768, 1363].includes(width)) return;
          this.querySelector('iframe').style.width = width + 'px';
          this.querySelectorAll('button[data-width]').forEach(option => {
            option.setAttribute('aria-pressed', option === button ? 'true' : 'false');
          });
        }, { signal: this.abortController.signal });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }
    }
    customElements.define('divaderme-preview-frame', DivadermePreviewFrame);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["divaderme-ritual-story"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('divaderme-ritual-story')) {
    class DivadermeRitualStory extends HTMLElement {
      connectedCallback() {
        this.frames = Array.from(this.querySelectorAll('.dd-ritual-frame'));
        this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.abortController = new AbortController();
        this.frameRequest = 0;
        this.nearViewport = true;
        this.schedule = this.schedule.bind(this);
        this.onPreferenceChange = this.onPreferenceChange.bind(this);
        this.motionPreference.addEventListener('change', this.onPreferenceChange, { signal: this.abortController.signal });
        window.addEventListener('resize', this.schedule, { passive: true, signal: this.abortController.signal });
        window.addEventListener('scroll', this.schedule, { passive: true, signal: this.abortController.signal });
        this.addEventListener('load', this.schedule, { capture: true, signal: this.abortController.signal });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.nearViewport = entries.some(entry => entry.isIntersecting);
            if (this.nearViewport) this.schedule();
          }, { rootMargin: '200px 0px' });
          this.observer.observe(this);
        }
        this.onPreferenceChange();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.observer?.disconnect();
        if (this.frameRequest) cancelAnimationFrame(this.frameRequest);
        this.frameRequest = 0;
      }

      onPreferenceChange() {
        this.motionEnabled = !this.motionPreference.matches && this.dataset.designMode !== 'true';
        if (!this.motionEnabled) {
          if (this.frameRequest) cancelAnimationFrame(this.frameRequest);
          this.frameRequest = 0;
          this.frames.forEach(frame => frame.style.removeProperty('--dd-drift'));
        } else {
          this.schedule();
        }
      }

      schedule() {
        if (!this.motionEnabled || !this.nearViewport || this.frameRequest) return;
        this.frameRequest = requestAnimationFrame(() => {
          this.frameRequest = 0;
          if (!this.isConnected) return;
          const viewport = window.innerHeight;
          const distance = window.innerWidth < 700 ? 4 : 10;
          const updates = this.frames.map(frame => {
            const rect = frame.parentElement.getBoundingClientRect();
            if (rect.bottom < -100 || rect.top > viewport + 100) return null;
            const progress = Math.max(-1, Math.min(1, (viewport / 2 - (rect.top + rect.height / 2)) / (viewport / 2 + rect.height / 2)));
            return [frame, Math.round(progress * distance)];
          });
          updates.forEach(update => {
            if (update) update[0].style.setProperty('--dd-drift', update[1] + 'px');
          });
        });
      }
    }
    customElements.define('divaderme-ritual-story', DivadermeRitualStory);
  }
  } catch(e) { console.error(e); }
})();

})();
